import LanguageTag from '../../utils/LanguageTag';
import {getObjectKeyOfLength, isEmptyObject} from './Objects';
import {getDefaultLabels, getLocaleDateStrings} from './Labels';

let _instances = {};

function MonthNames(locale, labels) {
    this.monthNames =
        getObjectKeyOfLength(labels, 'monthNames', 12) ||
        getLocaleDateStrings(locale, {month: 'long'}, true) ||
        getDefaultLabels('monthNames') ||
        [];
    this.shortMonthNames =
        getObjectKeyOfLength(labels, 'shortMonthNames', 12) ||
        getLocaleDateStrings(locale, {month: 'short'}, true) ||
        getDefaultLabels('shortMonthNames') ||
        [];
}

MonthNames.prototype.getMonthNames = function() {
    return this.monthNames;
};

MonthNames.prototype.getShortMonthNames = function() {
    return this.shortMonthNames;
};

function getMonthNamesInstance(locale, labels) {
    const languageTag = locale ? new LanguageTag(locale) : {};
    const code = languageTag.code;

    labels = labels || {};

    if (!isEmptyObject(labels)) {
        return new MonthNames(languageTag.code, labels);
    }

    if (!_instances[code]) {
        _instances[code] = new MonthNames(languageTag.code, labels);
    }

    return _instances[code];
}

export {getMonthNamesInstance};
